YP.EventTag = function() {
    var $tagSelected = [];
    var $reset = false;

    var eventTagContainer = $('.event-tags-container');
    var eventTagContainerSelected = $('.event-tags-container_selected');
    var eventTagContainerProposal = $('.event-tags-container_proposal');
    var eventTagSearchHint = $('.event-tags-container_search-hint');
    var eventTagSearching = $('.event-tags-container_searching');
    var eventTagAddBlock = $('.event-tags-container_add-block');
    var eventTagAddLink = $('.event-tags-container_add-block_action');
    var eventTagItemSelector = '.js-event-tags_list_item';

    var eventTagInput = $('#event_tags_list');
    var typeEventInput = $('#event_type_event_id');
    var eventTagSearchInput = $('#event-tags-search');


    return {
        init: function() {
            this.initTypeEventInput();
            this.initEventTagSearchInput();
            this.initEventTagItems();

            $tagSelected = $('#event_tags_list').val();
            if ($tagSelected) {
                $tagSelected = $tagSelected.map(function(x) {
                    return parseInt(x, 10);
                });
            }
        },
        initTypeEventInput: function() {
            klass = this;
            if (typeEventInput.val()) {
                eventTagSearchInput.prop('disabled', false);
            }

            typeEventInput.change(function(e) {
                typeEventId = $(this).val();

                if (typeEventId) {
                    $reset = true;
                    klass.refreshEventTagList(typeEventId);
                    eventTagSearching.show();
                    eventTagInput.children().removeProp('selected');
                    eventTagContainerSelected.html('');
                    eventTagSearchInput.prop('disabled', false);
                } else {
                    klass.cleanEventTagList();
                    eventTagSearchInput.prop('disabled', true);
                }

            });
            typeEventInput.prop('disabled', false);
        },
        refreshEventTagList: function(typeEventId, search) {
            klass = this;
            view = "";

            eventTagAddBlock.hide();
            if (search) {
                eventTagSearchHint.show();
            }
            eventTagContainerProposal.hide();

            $.ajax({
                type: 'GET',
                url: eventTagContainer.data('url'),
                dataType: 'json',
                data: {
                    typeEventId: typeEventId,
                    search: search
                },
                success: function(data) {
                    view = data.view;
                    eventTagSearching.hide();
                    eventTagSearchHint.hide();
                    // if (search && (data.count === 0 || !data.exists_strict)) {
                    //     klass.initAddEventTagLink();
                    if (search !== null) {
                        //Search Case
                        //Move all element selected in proposal block to selected block
                        elements = eventTagContainerProposal.find('.active').detach();
                        eventTagContainerSelected.append(elements);

                        if (data.count === 0 || !data.exists_strict) {
                            klass.initAddEventTagLink();
                        }
                    }

                    eventTagContainerProposal.html(view);
                    if ($tagSelected && $reset == false) {
                        eventTagContainerProposal.find(eventTagItemSelector).each(function(index) {
                            tagId = $(this).data('id');
                            if ($tagSelected.indexOf(tagId) != -1) {
                                $(this).remove();
                            }
                        });
                    }

                    $reset = false;

                    eventTagContainerProposal.show();

                }
            });
        },
        cleanEventTagList: function() {
            eventTagContainerProposal.html('');
            eventTagInput.children().removeProp('selected');
        },
        initEventTagSearchInput: function() {
            klass = this;

            var typingTimer; //timer identifier
            var doneTypingInterval = 500; //time in ms, 5 second for example

            //on keyup, start the countdown
            eventTagSearchInput.on('keyup', function() {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            });

            //on keydown, clear the countdown
            eventTagSearchInput.on('keydown', function() {
                clearTimeout(typingTimer);
            });

            //user is "finished typing," do something
            function doneTyping() {
                search = eventTagSearchInput.val();
                typeEventId = typeEventInput.val();

                klass.refreshEventTagList(typeEventId, search);
            }
        },
        initAddEventTagLink: function() {
            klass = this;
            search = eventTagSearchInput.val();

            if (search.match(/^[\s0-9a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]+$/)) {
                eventTagAddBlock.show();
            }

            eventTagAddLink.off().on('click', function(e) {
                e.preventDefault();
                eventTagAddBlock.hide();
                search = eventTagSearchInput.val();
                typeEventId = typeEventInput.val();

                fakeElement =
                    $('<div class="js-event-tags_list_item s-tag s-tag_color_grey mr-s active s-tag_selected">' + search + ' <i class="fa fa-check pl-xs" aria-hidden="true"></i></div>');
                eventTagContainerSelected.append(fakeElement);


                $.ajax({
                    type: 'POST',
                    url: $(this).attr('href'),
                    dataType: 'json',
                    data: {
                        typeEventId: typeEventId,
                        label: search
                    },
                    success: function(data) {
                        view = data.view;
                        fakeElement.replaceWith(view).addClass('active');
                        klass.addOptionToEventTagInput(data.id);
                        klass.setValueToEventTagInput();
                        eventTagSearchInput.val('');
                        klass.refreshEventTagList(typeEventInput.val(),eventTagSearchInput.val());
                    }
                });


            })
        },
        initEventTagItems: function() {
            klass = this;
            eventTagContainer.off().on('click', eventTagItemSelector, function(e) {
                $(this).toggleClass('active').toggleClass('s-tag_selected');
                klass.setValueToEventTagInput();
                if(eventTagSearchInput.val() != ""){
                    eventTagSearchInput.val('');
                    klass.refreshEventTagList(typeEventInput.val(),eventTagSearchInput.val());
                }
            });
        },
        addOptionToEventTagInput: function(id) {
            eventTagInput.append($('<option>', {
                value: id,
                text: id
            }))
        },
        setValueToEventTagInput: function() {
            eventTagInput.children().removeProp('selected');
            $tagSelected = [];
            $(eventTagItemSelector).each(function(index) {
                if ($(this).hasClass('active')) {
                    $tagSelected.push($(this).data('id'));
                }
            });
            eventTagInput.val($tagSelected);
        }
    };
};

window.addEventListener("load", function() {
    if ($('.event-tags-js').length) {
        YP.EventTag().init();
    }
});
